<!-- ALL ORIGINAL STRUCTURE COMMENTED OUT LINE BY LINE (SuperPrompt V8) -->
<!-- <style> -->
<!--   .theme-white th { -->
<!--       background-color: #c25423 !important; -->
<!--   } -->
<!--   ul.entity-list{ -->
<!--     max-height: calc(100vh - 255px); -->
<!--     overflow: auto; -->
<!--   } -->
<!-- </style> -->
<!-- <div class="main-modal"> -->
<!--   <div class="modal-header"> -->
<!--     <h4> -->
<!--       Alert -->
<!--       <i class="fa fa-times pull-right hoverable" ng-click="$close()"></i> -->
<!--     </h4> -->
<!--   </div> -->
<!--   <div class="modal-body" ng-class="ctrl.currentTheme"> -->
<!--     -->
<!--     <div ng-if="ctrl.loading" class="text-center"> -->
<!--       <i class="fa fa-spin fa-spinner fa-3x"></i> -->
<!--     </div> -->
<!--  -->
<!--     <div ng-if="!ctrl.loading && ctrl.entities.length > 0 "> -->
<!--       <h5>The following entities will be re-exported to efile. do you want to continue?</h5> -->
<!--       <ul class="entity-list"> -->
<!--         <li ng-repeat="entity in ctrl.entities"> -->
<!--           {{::entity.leid}}/{{::entity.cdr_no}}/{{::entity.reporting_period}} -->
<!--         </li> -->
<!--       </ul> -->
<!--     </div> -->
<!--  -->
<!--     <div ng-if="!ctrl.loading && ctrl.entities.length === 0  && ctrl.status !== 'Failed'"> -->
<!--       All entities are successfully exported to Efile -->
<!--     </div> -->
<!--     -->
<!--     <div ng-if="!ctrl.loading && ctrl.entities.length === 0  && ctrl.status === 'Failed'"> -->
<!--       All entities are successfully exported to Efile. <br/>Something went wrong during post processing, would you like to continue with the retry? -->
<!--     </div> -->
<!--  -->
<!--     <div ng-if="!ctrl.loading && ctrl.status === 'In Progress'"> -->
<!--       Current request is In Progress. -->
<!--     </div> -->
<!--  -->
<!--     <div ng-if="!ctrl.loading && ctrl.userInitiatedRequest"> -->
<!--       Only the Requests that are raised by the system can be retried. User generated requests needs to be requested again from Efile View. -->
<!--     </div> -->
<!--   </div> -->
<!--  -->
<!--   <div class="modal-footer" ng-if="(!ctrl.loading && (ctrl.entities.length > 0 && ctrl.status === 'Partially Completed') )  -->
<!--     || (!ctrl.loading && ctrl.status === 'Failed' )"  -->
<!--     ng-class="ctrl.currentTheme"> -->
<!--     <button class="btn btn-primary" ng-click="ctrl.retryBulkExport()">Continue</button> -->
<!--   </div> -->
<!-- </div> -->

<!-- CUSTOM ELEMENT INTEGRATION (SuperPrompt V8) -->
<div class="main-modal">
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Alert</h4>
    <div class="header-actions">
      <i (click)="close()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [ngClass]="currentTheme">
    
    <!-- Loading state -->
    @if (loading) {
<div class="text-center">
      <i class="fa fa-spin fa-spinner fa-3x"></i>
    </div>
}

    <!-- Show entities list when there are failed entities -->
    @if (!loading && entities.length > 0) {
<div>
      <h5>The following entities will be re-exported to efile. Do you want to continue?</h5>
      <ul class="entity-list">
        @for (entity of entities; track $index) {
<li>
          {{entity.leid}}/{{entity.cdr_no}}/{{entity.reporting_period}}
        </li>
}
      </ul>
    </div>
}

    <!-- All entities successfully exported (not failed status and not in progress) -->
    @if (!loading && entities.length === 0 && status !== 'Failed' && status !== 'In Progress') {
<div>
      All entities are successfully exported to Efile
    </div>
}
    
    <!-- All entities successfully exported (failed status) -->
    @if (!loading && entities.length === 0 && status === 'Failed') {
<div>
      All entities are successfully exported to Efile. <br/>Something went wrong during post processing, would you like to continue with the retry?
    </div>
}

    <!-- Request in progress message -->
    @if (!loading && status === 'In Progress') {
<div>
      Current request is In Progress.
    </div>
}

    <!-- User initiated request message -->
    @if (!loading && userInitiatedRequest) {
<div>
      Only the Requests that are raised by the system can be retried. User generated requests needs to be requested again from Efile View.
    </div>
}
  </div>

  <!-- Modal Footer -->
  @if ((!loading && (entities.length > 0 && status === 'Partially Completed')) || (!loading && status === 'Failed')) {
<div class="modal-footer" 
       
       [ngClass]="currentTheme">
    <button class="continue-button" 
            type="button" 
            (click)="retryBulkExport()">Continue</button>
  </div>
}
</div>
